import React from "react";
import "./ai-demand-content.component.scoped.scss";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../statics/icons";
import CasesContent from "../cases-content/cases-content.component";
import { CASES_PAGE_TYPES } from "../../../types/AI-roles";
import { ContentLayout } from "../../../../../layouts/content/content.layout";
import PagesHeadComponent from "../../../../../components/pages-head-component/pages-head.component";

const AIDemandContentComponent = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <ContentLayout>
        <PagesHeadComponent
          title={t("PAGES_HEAD.AI_DEMAND_TITLE")}
          subTitle={t("PAGES_HEAD.AI_DEMAND_SUB_TITLE")}
          logo={icons.PAGES.HEAD.AI_DEMAND}
        />
        <CasesContent casesPageType={CASES_PAGE_TYPES.DEMAND} />
      </ContentLayout>
    </Box>
  );
};

export default AIDemandContentComponent;
